import {
  Component, ChangeDetectionStrategy, Input, Output, ViewChild, TemplateRef, ElementRef,
  HostListener, OnInit, Injectable, OnChanges, EventEmitter
} from '@angular/core';
import { CommonService } from '../services/common.service';
import * as moment from 'moment';

@Component({
  selector: 'app-select-periode',
  templateUrl: './select-periode.component.html',
  styleUrls: ['./select-periode.component.css']
})
export class SelectPeriodeComponent implements OnInit {
  dateDebut;
  dateFin;
  @Input() dateVide;
  @Input() useDateInPlaningEcoloc;
  @Output() validerfct = new EventEmitter<any>();

  constructor(public common: CommonService) { }

  ngOnInit() {
      if (this.useDateInPlaningEcoloc) {
        if (this.common.defaultViewPlanningEcoloc) {
          this.dateDebut = this.common.parseDate(moment(this.common.defaultViewPlanningEcoloc.date).format('DD/MM/YYYY'));
          this.dateFin = this.common.parseDate(this.common.defaultViewPlanningEcoloc['datefinPlanning']);
        }
      }
  }

    changeDate($event, istrue ?) {
      if (istrue) {
        this.dateDebut = $event;
      } else {
        this.dateFin = $event;
      }
    }

    valider() {
      this.common.closeModal();
      const info = { dateDebut: this.dateDebut, dateFin: this.dateFin };
      this.validerfct.emit(info);
    }

  }
